import { render, staticRenderFns } from "./Ads.vue?vue&type=template&id=7bee216c&lang=pug"
import script from "./Ads.vue?vue&type=script&lang=js"
export * from "./Ads.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports